import { toast as sonnerToast } from 'sonner';
import i18n from './i18n';

/**
 * Translated toast utility that wraps sonner's toast
 * Uses i18n to get translated messages from the notifications namespace
 */
export const toast = {
  /**
   * Show a success toast with a translated message
   * @param key - Translation key in format "namespace.key" (e.g., "auth.loginSuccess")
   * @param fallback - Optional fallback message if translation not found
   */
  success: (key: string, fallback?: string) => {
    const message = i18n.t(`notifications:${key}`, fallback || key);
    sonnerToast.success(message);
  },

  /**
   * Show an error toast with a translated message
   * @param key - Translation key in format "namespace.key" (e.g., "auth.loginFailed")
   * @param fallback - Optional fallback message or API error message
   */
  error: (key: string, fallback?: string) => {
    const message = i18n.t(`notifications:${key}`, fallback || key);
    sonnerToast.error(message);
  },

  /**
   * Show an info toast with a translated message
   */
  info: (key: string, fallback?: string) => {
    const message = i18n.t(`notifications:${key}`, fallback || key);
    sonnerToast.info(message);
  },

  /**
   * Show a warning toast with a translated message
   */
  warning: (key: string, fallback?: string) => {
    const message = i18n.t(`notifications:${key}`, fallback || key);
    sonnerToast.warning(message);
  },

  /**
   * Show a loading toast - returns toast ID for updating later
   */
  loading: (key: string, fallback?: string) => {
    const message = i18n.t(`notifications:${key}`, fallback || key);
    return sonnerToast.loading(message);
  },

  /**
   * Dismiss a toast by ID
   */
  dismiss: (toastId?: string | number) => {
    sonnerToast.dismiss(toastId);
  },

  /**
   * Show raw message without translation (for API error messages)
   */
  raw: {
    success: (message: string) => sonnerToast.success(message),
    error: (message: string) => sonnerToast.error(message),
    info: (message: string) => sonnerToast.info(message),
    warning: (message: string) => sonnerToast.warning(message),
  },
};

export default toast;

